import { useFetchedCampaign } from 'modules/campaigns/hooks/useFetchedCampaign';

export const useCampaignRecommendation = ({ recommendation }) => {
    const { campaignId, accountName: accountId } = recommendation;
    const { campaign } = useFetchedCampaign(campaignId);
    return { campaign, campaignId, accountId };
};
